/**
 * Supabase connection, read at build time from VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
 * (VITE_SUPABASE_PUBLISHABLE_KEY is accepted too). See .env.example.
 * Without them the app runs as in Queue 2: no account, data only in this browser.
 */
export interface CloudConfig { url: string; anonKey: string }

export function cloudConfig(): CloudConfig | null {
  const env = import.meta.env;
  const url = String(env.VITE_SUPABASE_URL ?? "").trim().replace(/\/+$/, "");
  const anonKey = String(env.VITE_SUPABASE_ANON_KEY ?? env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "").trim();
  return url && anonKey ? { url, anonKey } : null;
}
